import type { RxJsonSchema } from 'rxdb';
import type { DeficiencyList } from './deficiencyList.types';

export const deficiencyListSchema: RxJsonSchema<DeficiencyList> = {
  type: 'object',
  version: 2,
  description: 'describes deficiency lists',
  primaryKey: 'componentVersionUUID',
  properties: {
    pkDeficiencyUUID: { type: 'string', maxLength: 36 },
    componentFailureId: { type: 'string' },
    pcsId: { type: ['string', 'null'] },
    repairFactorId: { type: ['number', 'null'] },
    isCompletedDuringInspection: { type: ['boolean', 'null'] },
    componentType: { type: ['string', 'null'] },
    remedialAction: { type: ['string', 'null'] },
    causeOfFailure: { type: ['string', 'null'] },
    remedialActionId: { type: ['number', 'null'] },
    commentRemedialAction: { type: ['string', 'null'] },
    assetCategoryComponentId: { type: ['number', 'null'] },
    commentAssetComponent: { type: ['string', 'null'] },
    assetInspectionId: { type: ['number', 'null'] },
    failureCauseCategory: { type: ['number', 'null'] },
    areaId: { type: ['number', 'null'] },
    fkAsset: { type: ['number', 'null'] },
    fkArea: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    isAdhoc: { type: ['boolean', 'null'] },
    locationDescription: { type: ['string', 'null'] },
    commentObservation: { type: ['string', 'null'] },
    name: { type: ['string', 'null'] },
    dateObserved: { type: ['string', 'null'] },
    site: { type: 'number' },
    discipline: { type: 'number' },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isDelete: { type: ['string', 'null'] },
    fieldInspectorId: { type: ['number', 'null'] },
    leadInspectorId: { type: ['number', 'null'] },
    inspectionTaskId: { type: ['number', 'null'] },
    commentSiteCoordinator: { type: ['string', 'null'] },
    commentInspectorLead: { type: ['string', 'null'] },
    commentInspectorField: { type: ['string', 'null'] },
    attentionFlag: { type: ['boolean', 'null'] },
    isReInspectedComponent: { type: ['boolean', 'null'] },
    taskStatusCategory: { type: ['number', 'null'] },
    fkComponent: { type: ['number', 'null'] },
    lowerElevation: { type: ['string', 'null'] },
    upperElevation: { type: ['string', 'null'] },
    role: { type: ['number', 'null'] },
    componentAreaInfo: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          componentFailureId: { type: ['number', 'null'] },
          areaId: { type: ['number', 'null'] },
          areaPcsId: { type: ['string', 'null'] },
          inspectionId: { type: ['number', 'null'] },
          trafficSafety: { type: ['number', 'null'] },
        },
      },
    },
    inspectorOperationalDowntime: { type: ['number', 'null'] },
    inspectorConditionRating: { type: ['number', 'null'] },
    inspectorUrgency: { type: ['number', 'null'] },
    inspectorTrafficScore: { type: ['number', 'null'] },
    componentVersionId: { type: ['number', 'null'] },
    componentVersionInspectionId: { type: ['number', 'null'] },
    componentVersionUUID: { type: 'string', maxLength: 36 },
  },
};
